import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"view-in-ar"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M18.0614 8.49977L11.9997 5L5.93836 8.4995L5.9375 15.5L11.9997 19L18.0619 15.5L18.0614 8.49977Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12.0001 11.9993L11.9999 11.9992L11.9998 11.9993M12.0004 11.9993V18.25M17.3 8.93923L12.5 11.7105M6.7 8.93923L11.5 11.7105M11.9997 5L18.0614 8.49977L18.0619 15.5L11.9997 19L5.9375 15.5L5.93836 8.4995L11.9997 5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M18.5 21.5H21.5V18.5M18.5 2.5H21.5V5.5M5.5 21.5H2.5V18.5M5.5 2.5H2.5V5.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ViewInAr = Vue.extend<IconProps>({
  name: 'ViewInArIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'view-in-ar',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ViewInAr;
